import {Drawer, Stack, TextField, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {addEstimation, EstimationModel} from "../../firebase/index.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import {hideNumberSpinner, singleLineText} from "../../reusables/js/APXCrucialStyles.js";
import {additionalHeaders, estKeys, rowKeyHeaders} from "./EstimationUtil.js";


export default function AddNewEstimationBSL({uid, onClose, estimation}: BSLProps & { estimation: EstimationModel }) {
	  
	  const [destination, setDestination] = useState("");
	  const [persons, setPersons] = useState(1);
	  const [nights, setNights] = useState(1);
	  const [primaryFarePP, setPrimaryFarePP] = useState(0);
	  const [secondaryFarePP, setSecondaryFarePP] = useState(0);
	  const [roomCostPPPN, setRoomCostPPPN] = useState(0);
	  const [foodCostPPPD, setFoodCostPPPD] = useState(0);
	  const [sightseeing, setSightseeing] = useState(0);
	  const [shopping, setShopping] = useState(0);
	  const [extras, setExtras] = useState(0);
	  
	  const [estimationKey, setEstimationKey] = useState("");
	  useEffect(() => {
			 if (/*TRUTHY->*/ !!estimation) {
					const e: EstimationModel = estimation;
					setEstimationKey(e.estimationKey);
					setDestination(e.destination);
					setPersons(e.persons);
					setNights(e.nights);
					setPrimaryFarePP(e.primaryFarePP);
					setSecondaryFarePP(e.secondaryFarePP);
					setRoomCostPPPN(e.roomCostPPPN);
					setFoodCostPPPD(e.foodCostPPPD);
					setSightseeing(e.sightseeing);
					setShopping(e.shopping);
					setExtras(e.extras);
			 }
	  }, [estimation]);
	  
	  const {isOpen, handleOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  
	  const handleCancel = () => {
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 if (/*FALSY->*/ !!!uid) {
					alert("Login to add new Estimation");
					return;
			 }
			 if (destination.trim() === "" || persons <= 0 || nights <= 0 || primaryFarePP <= 0 || secondaryFarePP <= 0 || roomCostPPPN <= 0 || foodCostPPPD <= 0 || sightseeing < 0 || shopping < 0 || extras < 0) {
					alert("Please fill all the fields");
					return;
			 }
			 
			 const total = Math.round(
						(primaryFarePP * persons)
						+ (secondaryFarePP * persons)
						+ (roomCostPPPN * persons * nights)
						+ (foodCostPPPD * persons * (nights + 1))
						+ sightseeing
						+ shopping
						+ extras
			 );
			 const perHead = Math.round(total / persons);
			 
			 const estimation = new EstimationModel(destination, persons, nights, primaryFarePP, secondaryFarePP, roomCostPPPN, foodCostPPPD, sightseeing, shopping, extras, total, perHead);
			 estimation.estimationKey = estimationKey || Date.now().toString();
			 
			 addEstimation(uid, estimation.estimationKey, estimation);
			 
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  
							  <Stack direction={"row"} spacing={2} justifyContent={"space-evenly"}>
									 {Object.values(additionalHeaders).map((header) => (
												<Typography key={header}
																fontSize={8}
																fontWeight={"bold"}
																sx={singleLineText}
												>
													  {header}
												</Typography>
									 ))}
							  </Stack>
							  
							  <TextField required label={rowKeyHeaders[estKeys.destination]} variant="outlined" fullWidth
											 value={destination}
											 onChange={(e) => setDestination(e.target.value)}/>
							  <Stack direction="row" spacing={1}>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.persons]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={persons}
													onChange={(e) => setPersons(Number(e.target.value))}/>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.nights]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={nights}
													onChange={(e) => setNights(Number(e.target.value))}/>
							  </Stack>
							  <Stack direction="row" spacing={1}>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.primaryFarePP]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={primaryFarePP}
													onChange={(e) => setPrimaryFarePP(Number(e.target.value))}/>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.secondaryFarePP]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={secondaryFarePP}
													onChange={(e) => setSecondaryFarePP(Number(e.target.value))}/>
							  </Stack>
							  <Stack direction="row" spacing={1}>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.roomCostPPPN]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={roomCostPPPN}
													onChange={(e) => setRoomCostPPPN(Number(e.target.value))}/>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.foodCostPPPD]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={foodCostPPPD}
													onChange={(e) => setFoodCostPPPD(Number(e.target.value))}/>
							  </Stack>
							  <Stack direction="row" spacing={1}>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.sightseeing]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={sightseeing}
													onChange={(e) => setSightseeing(Number(e.target.value))}/>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.shopping]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={shopping}
													onChange={(e) => setShopping(Number(e.target.value))}/>
									 <TextField required type={"number"} label={rowKeyHeaders[estKeys.extras]} variant="outlined" InputProps={hideNumberSpinner} fullWidth
													value={extras}
													onChange={(e) => setExtras(Number(e.target.value))}/>
							  </Stack>
							  
							  <APXActionButtons onCancel={handleCancel} onAdd={handleAdd}/>
						</Stack>
				 </Drawer>
	  );
}